<ion-header>
  <app-header-small title="Checkout" [isScrollStartPosition]="isScrollStartPosition" [showLocationModal]="true"></app-header-small>
</ion-header>
<app-product-modal
  [defaultProduct]="selectedProduct"
  [restaurant]="selectedLocation"
  [locationId]="selectedLocationId"
  [isClosed]="isRestaurantClosed"
  [allowScheduledPickups]="selectedLocation.allowScheduledPickups"
  [isMobileEnabled]="selectedLocation.isMobileEnabled"
  [isModal]="true"
  [enforceInventory]="selectedLocation.enforceInventory"
  [hoursOfOperation]="selectedLocation.hoursOfOperation"
  [cartProduct]="selectedCartProduct"
  [currencySign]="currencySign"
  [isRestaurantHaveEnabledWorkDays]="true"
  *ngIf="isShowProductModal"
  (close)="closeProductModal()"
  (addItem)="onEditItemToCart($event)"
>
</app-product-modal>
<ion-content [scrollEvents]="true" (ionScroll)="updateHeaderLogo($event)">
  <div class="container">
    <div class="container__content" *ngIf="!isTab">
      <div class="field">
        <div class="field__title" *ngIf="!sharedOrderId">
          {{selectedFulfillmentTypeItem?.title === 'Tableside' && isSkybox ? 'Order to Your Skybox' : selectedFulfillmentTypeItem?.title}}
          <svg class="field__title-icon field__title-icon--big" viewBox="0 0 14 18" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="./assets/images/icons-sprite.svg#icon-pin"></use>
          </svg>
        </div>
        <div class="field__description" *ngIf="!isGroup; else groupDescription">Location
          <span *ngIf="restaurant">- {{restaurant.address.addressLine}}</span>
        </div>
        <ng-template #groupDescription class="field__description">Group
          <span *ngIf="group">- {{group.address.addressLine}}</span>
        </ng-template>
        <div class="field__content" *ngIf="showFulfillmentTypes && !sharedOrderId">
          <app-tip-radio-group [(ngModel)]="selectedFulfillmentTypeItem" [items]="fulfillmentTypeItems">
            <ng-template #item let-item let-checked="checked">
              <div class="location-tip" [class.location-tip--checked]="checked">
                <div class="location-tip__title">{{item.title === 'Tableside' && isSkybox ? 'Skybox' : item.title}}
                  <svg class="location-tip__title-icon" [class.location-tip__title-icon--wide]="item.wideIcon"
                       xmlns="http://www.w3.org/2000/svg">
                    <use [attr.xlink:href]="getFulfillmentItemIcon(item)"></use>
                  </svg>
                </div>
              </div>
            </ng-template>
          </app-tip-radio-group>
        </div>
      </div>
      <ng-container *ngIf="isShowTableNumberField">
        <div class="field" #tableNumberField>
          <div class="field__title">{{isSkybox ? 'Skybox' : 'Table'}} number
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-sharp"></use>
            </svg>
          </div>
          <div class="field__description" *ngIf="!isTableNumberExpanded">
            {{isSkybox ? 'Skybox' : 'Table'}}
            <span>- {{paymentStore.tableNumber}}</span>
            <ion-button
              size="small"
              fill="clear"
              color="brand"
              [disabled]="paymentStore.isWaitingUpdate"
              *ngIf="restaurant?.allowEditTableNumber"
              (click)="showTableNumberExpanded = true;"
              class="edit-tip-button">
              Edit
            </ion-button>
          </div>
          <div [hidden]="!isTableNumberExpanded">
            <ion-text class="field__description">Enter your {{isSkybox ? 'Skybox' : 'table'}} number</ion-text>
            <div class="field__content">
              <input name="table-number"
                     id="table-number"
                    type="text"
                    (focusin)="onFocusInTableNumber()"
                    (focusout)="onFocusOutTableNumber()"
                    [(ngModel)]="paymentStore.tableNumber"
                    placeholder="Enter your {{isSkybox ? 'Skybox' : 'table'}} number"
                    pattern="[a-zA-Z0-9]+"
                    maxlength="20"
                    class="table-number"/>
              <p class="field__content-error" *ngIf="showTableNumberError">
                Please enter a {{isSkybox ? 'Skybox' : 'table'}} number
              </p>
            </div>
          </div>
        </div>
        <div class="field" *ngIf="isTabsEnabled" #enableTabField>
          <div class="field__title">Keep a tab open?
            <span *ngIf="isStrictTabLanguageEnabled">(optional)</span>
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-sharp"></use>
            </svg>
          </div>
          <ion-label color="main-dark" class="enable-tab__label-text">
            Leave your tab open to add to your order later
          </ion-label>
          <ion-list lines="none" class="enable-tab__list">
            <ion-radio-group>
              <ion-item class="enable-tab__list-item" no-lines>
                <ion-radio
                  class="enable-tab__list-item-radio"
                  color="main-dark"
                  mode="md"
                  (ionSelect)="allowCreateTab(true)">
                </ion-radio>
                <ion-label class="enable-tab__label-text-radio" [color]="'main-dark'">
                  Yes<span *ngIf="isStrictTabLanguageEnabled">, I agree to a temporary {{authAmountInCents}} card authorization hold (usually updated within 48 hours)</span>
                </ion-label>
              </ion-item>
              <ion-item class="enable-tab__list-item" no-lines>
                <ion-radio
                  class="enable-tab__list-item-radio"
                  color="main-dark"
                  mode="md"
                  (ionSelect)="allowCreateTab(false)">
                </ion-radio>
                <ion-label class="enable-tab__label-text-radio" [color]="'main-dark'">
                  No
                </ion-label>
              </ion-item>
            </ion-radio-group>
          </ion-list>
          <p class="field__content-error" *ngIf="showEnableTabError">
            Please select an option
          </p>
          <div class="note__block" *ngIf="paymentStore.createTabChecked">
            <span class="note__text" >
              NOTE: If you keep a tab open, your card may be <span [ngClass]="{'note__text-bold' : isStrictTabLanguageEnabled}">temporarily</span> authorized for more than your final order total. This will be adjusted after the tab is closed. After {{closeInactiveTabsAfterMinutes}} minutes of inactivity, your tab will automatically close with a {{autoGratuityPercent}}% auto-gratuity. If using a prepaid/stored-value card, select 'No' under 'Keep a tab open' and ensure your card has adequate balance.
            </span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="showPickupField && !sharedOrderId">
        <div class="field" #scheduledPickupField *ngIf="isAllowScheduledPickups">
          <div class="field__title">{{pickupDateTimeLabelText}}
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-time"></use>
            </svg>
          </div>
          <ion-text class="field__description">{{pickupDateTimeDescriptionText}}</ion-text>
          <div class="field__content">
              <app-scheduled-pickup-timepicker *ngIf="isShowTimePicker" [forceTouched]="forceTouched" [acceptOrders]="isAcceptOrders"
                                               [hoursOfOperation]="workHoursDaysInAdvance" (validChange)="schedulePickupInvalid = !$event"
                                               [estimatedTimeInMinutes]="estimatedTimeInMinutes" [hideETA]="hideETA"
                                               [pickupDaysInAdvance]="pickupDaysInAdvance" [disableASAP]="isDisableAsap"
                                               [selectASAP]="selectAsapInTimepicker" [showWindowEndTime]="showWindowEndTime"
                                               [hidePickupTime]="isHidePickupTime" [shifts]="shifts" 
                                               [useFlavorShifts]="isUseFlavorShiftsTime"
                                               >
              </app-scheduled-pickup-timepicker>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="isDeliverySelected">
        <app-scheduled-pickup-timepicker [hidden]="true" [forceTouched]="forceTouched" [acceptOrders]="isAcceptOrders"
          [hoursOfOperation]="workHoursDaysInAdvance" (validChange)="schedulePickupInvalid = !$event"
          [estimatedTimeInMinutes]="estimatedTimeInMinutes" [hideETA]="hideETA"
          [pickupDaysInAdvance]="pickupDaysInAdvance" [disableASAP]="isDisableAsap"
          [selectASAP]="selectAsapInTimepicker" [showWindowEndTime]="showWindowEndTime"
          [shifts]="shifts" [useFlavorShifts]="isUseFlavorShiftsTime">
        </app-scheduled-pickup-timepicker>
        <div class="field" #phoneField>
          <div class="field__title">Enter Number
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-call"></use>
            </svg>
          </div>
          <ion-text class="field__description">You will receive text messages with updated delivery information</ion-text>
          <ng-container *ngTemplateOutlet="phoneFieldTemplate"></ng-container>
          <div class="field__footer">
            Message and data rates may apply, reply HELP for help and STOP to cancel.
            <div>
              <span class="field__footer-link" (click)="openLink(termsLink)">Terms of Service</span>, <span class="field__footer-link" (click)="openLink(privacyLink)">Privacy Policy</span>
            </div>
          </div>
        </div>
        <div class="field" #deliveryAddressForm *ngIf="isShowDefaultDeliveryForm && merchant && !isUseFlavorShiftsTime">
          <div class="field__title">Delivery Address
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-delivery"></use>
            </svg>
          </div>
          <div class="field__label">
            <ion-label color="main-dark" class="field__checkbox-text">
              Save address for future orders (recommended)
            </ion-label>
            <ion-checkbox
              color="main-dark"
              class="field__checkbox"
              name="save-address"
              [checked]="saveDeliveryAddress"
              (ionChange)="changeSaveAddressValue($event.detail.checked)">
            </ion-checkbox>
          </div>
          <ion-item class="field__content" lines="full" *ngFor="let address of customerAddresses">
            <ion-label>{{getFormattedAddress(address)}}</ion-label>
            <ion-button class="ion-float-right" fill="clear" (click)="selectDeliveryAddress(address)" color="brand">Choose</ion-button>
          </ion-item>
          <div class="field__content">
            <input name="street-address"
                   id="delivery-street"
                   type="text"
                   [(ngModel)]="deliveryAddress.street"
                   (focusout)="preEstimateDelivery()"
                   (ngModelChange)="changeDeliveryAddress()"
                   placeholder="Street address"
                   class="delivery-address"/>
            <p class="field__content-error" *ngIf="showDeliveryAddressError(deliveryAddress.street)">
              Please enter a value for street address
            </p>
            <input name="suite-number"
                   id="delivery-room"
                   type="text"
                   [(ngModel)]="deliveryAddress.suite"
                   (ngModelChange)="changeDeliveryAddress()"
                   placeholder="Suite, Apt, Room number"
                   class="delivery-address"/>
            <div class="delivery-address__form-line">
              <div class="delivery-address__form-line-city">
                <input name="city"
                       id="delivery-city"
                       type="text"
                       [(ngModel)]="deliveryAddress.city"
                       (focusout)="preEstimateDelivery()"
                       (ngModelChange)="changeDeliveryAddress()"
                       placeholder="City"
                       class="delivery-address__input"/>
                <p class="field__content-error" *ngIf="showDeliveryAddressError(deliveryAddress.city)">
                  Please enter a value for city
                </p>
              </div>
              <div class="delivery-address__form-line-state">
                <input name="state"
                       id="delivery-state"
                       type="text"
                       [(ngModel)]="deliveryAddress.state"
                       (focusout)="preEstimateDelivery()"
                       (ngModelChange)="changeDeliveryAddress()"
                       placeholder="State"
                       class="delivery-address__input"/>
                <p class="field__content-error" *ngIf="showDeliveryAddressError(deliveryAddress.state)">
                  Please enter a value for state
                </p>
              </div>
              <div class="delivery-address__form-line-zip">
                <input name="postalCode"
                       id="delivery-zip"
                       type="text"
                       [(ngModel)]="deliveryAddress.postalCode"
                       (focusout)="preEstimateDelivery()"
                       (ngModelChange)="changeDeliveryAddress()"
                       placeholder="Zip"
                       class="delivery-address__input"/>
                <p class="field__content-error" *ngIf="showDeliveryAddressError(deliveryAddress.postalCode)">
                  Please enter a value for postal code
                </p>
              </div>
            </div>
            <textarea name="instructions"
                      class="delivery-address delivery-address__textarea"
                      placeholder="Enter special delivery instructions (i.e. leave by the door)"
                      [(ngModel)]="deliveryAddress.instructions"
                      maxlength="280"
                      (ngModelChange)="changeDeliveryAddress()">
            </textarea>
            <div class="note__block">
              <span class="note__text note__text--red" *ngIf="!isLoading && showErrorTextForDeliveryEstimate">
                {{errorTextForDeliveryEstimate}}
              </span>
            </div>
          </div>
        </div>

        <div class="field"
             *ngIf="showDeliveryLocations">
          <div class="field__title">Delivery Location
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-delivery"></use>
            </svg>
          </div>
          <ion-text class="field__description">Select location to receive your order</ion-text>
          <ion-button expand="black"
                      class="delivery-pickup-timepicker {{deliveryAddressText !== 'Choose delivery location' ? 'delivery-pickup-timepicker--filled' : ''}}"
                      (click)="openDeliveryLocationModal()">
            <div class="delivery-pickup-timepicker__container">
              <span>{{deliveryAddressText}}</span>
              <ion-icon *ngIf="restaurant.sellerDeliveryLocations.length && restaurant.sellerDeliveryLocations.length > 1"
                        [name]="isDateTimeModalOpen ? 'arrow-dropup' : 'arrow-dropdown'" class="ion-float-right"></ion-icon>
            </div>
          </ion-button>
          <p class="field__content-error" *ngIf="showDeliveryAddressError(selectedDeliveryLocation)">
            Please choose delivery location
          </p>
          <div class="delivery-addresses-wrap" *ngIf="isShowDeliveryLocationModal">
            <ng-container *ngFor="let deliveryAddress of deliveryLocations">
              <div class="address-list-item" (click)="selectDeliveryLocation(deliveryAddress)">
                {{deliveryAddress}}
              </div>
            </ng-container>
          </div>
        </div>

        <div class="field" id="deliveryTimePicker" *ngIf="deliveryTimePicker">
          <div class="field__title">Delivery Times
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-time"></use>
            </svg>
          </div>
          <ion-text class="field__description">Select a time to receive your order</ion-text>
          <div class="field__content">
            <ion-button #deliveryTimepicker expand="black"
                        id="delivery-time-btn"
                        class="delivery-pickup-timepicker {{deliveryTimePickerText !== 'Choose delivery time' ? 'delivery-pickup-timepicker--filled' : ''}}"
                        (click)="deliveryPickUpDateTime()">
              <div class="delivery-pickup-timepicker__container">
                <span>{{deliveryTimePickerText}}</span>
                <ion-icon [name]="isDateTimeModalOpen ? 'arrow-dropup' : 'arrow-dropdown'" class="ion-float-right"></ion-icon>
              </div>
            </ion-button>
            <p class="field__content-error" *ngIf="showDeliveryTimeError">
              Please choose delivery time
            </p>
          </div>
        </div>
      </ng-container>
      <div *ngIf="!showPhoneFieldBottom else phoneVerification"></div>

      <ng-container *ngIf="isSubscriptionCheckout">
        <div class="field" id="subscriptionPickupDays" #subscriptionDaysSelecting>
          <div class="field__title">Choose pickup day(s)
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-calendar"></use>
            </svg>
          </div>
          <ion-text class="field__description">Select which day(s) to pick up your order</ion-text>
          <div class="field__content">
            <app-multiselect [items]="daysToSelect" [isDisabled]="isCadenceEqualsValue('daily')"></app-multiselect>
            <p class="field__content-error" *ngIf="showSubscriptionDaySelectError">
              Please choose at least one day for subscription
            </p>
          </div>
          <ion-text class="field__disclaimer" *ngIf="isCadenceEqualsValue('daily')">By choosing daily you cannot change the number of days.</ion-text>
        </div>

        <div class="field" id="subscriptionPickupDays">
          <div class="field__title">Select subscription frequency
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-circle-arrow"></use>
            </svg>
          </div>
          <ion-text class="field__description">Select a time to pick up your order</ion-text>
          <div class="field__content">
            <ion-radio-group>
              <ion-item class="field__content-phase" lines="none" [class.field__content-phase-selected]="phase.selected" *ngFor="let phase of cartStore?.subscriptionsData">
                <ion-radio class="field__content-phase-radio" color="main-dark" mode="md"
                           [class.field__content-phase-radio-selected]="phase.selected"
                           [checked]="phase.selected"
                           (ionSelect)="selectSubscriptionPhase(phase)"></ion-radio>
                <ion-label class="field__content-phase-label" [class.field__content-phase-label-selected]="phase.selected">
                  {{phase.cadence | titlecase}}</ion-label>
                <div class="field__content-phase-buttons" *ngIf="phase?.cadence.toLowerCase() === 'monthly'"  #subscriptionPeriodSelecting>
                  <ion-button class="field__content-phase-button ion-float-right" fill="clear"
                              [class.field__content-phase-button-selected]="period.selected && phase.selected"
                              *ngFor="let period of phase.selectedPeriods"
                              (click)="selectSubscriptionPeriod(phase, period)">
                    {{period.param}}
                  </ion-button>
                </div>
              </ion-item>
            </ion-radio-group>
            <p class="field__content-error" *ngIf="showSubscriptionPeriodSelectError">
              Please choose at least one period for subscription
            </p>
          </div>
          <ion-text class="field__disclaimer">Deadline to cancel is {{deadlineTime}} before pickup.</ion-text>
        </div>
      </ng-container>

      <ng-container *ngIf="restaurant && restaurant.isShowAddons">
        <app-item-suggestions [locationId]="locationId" [restaurant]="restaurant"></app-item-suggestions>
      </ng-container>

      <div class="field">
        <div class="field__title display-flex">Order summary
          <svg class="field__title-icon field__title-icon--large" xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="./assets/images/icons-sprite.svg#icon-cart"></use>
          </svg>
          <button class="refresh-cart-btn" *ngIf="sharedOrderService.sharedOwnerId$"
                  [class.buttn-disabled]="disabledSubmit"
                  [disabled]="disabledSubmit"
                  (click)="sharedOrderService.getAllSharedOrders(locationId)">
            Refresh Cart  <mat-icon>refresh</mat-icon>
          </button>
        </div>
        <div class="field__content">
          <app-loyalty-banner *ngIf="showLoyaltyBanner" [withBorder]="false" [loyaltyBannerType]="loyaltyBannerType"></app-loyalty-banner>

          <div class="field__loyalty" *ngIf="isShowUseLoyaltyCheckbox">
            <span class="field__loyalty-title">Yay, you're eligible for a reward!</span>
            <div class="field__loyalty-checkbox">
              <ion-checkbox color="main-dark" class="field__loyalty-checkbox-button" name="use-loyalty"
                          disabled="{{isDisablingCheckoutInfo}}"
                          [checked]="paymentStore.useLoyaltyChecked"
                          (ionChange)="changeUseLoyaltyPoints($event.detail.checked)">
              </ion-checkbox>
              <ion-label color="main-dark" class="field__loyalty-checkbox-text">
                Redeem {{pointsName.other}} on this order.
              </ion-label>
            </div>
            <ion-radio-group *ngIf="isShowUseLoyaltyRadioGroup">
              <ion-item class="field__loyalty-list-item" no-lines *ngFor="let reward of filteredLoyaltyRewards">
                <ion-radio class="field__loyalty-list-item-radio"
                           color="main-dark" mode="md"
                           disabled="{{isDisablingCheckoutInfo}}"
                           [checked]="isActiveLoyaltyReward(reward)"
                           (ionSelect)="selectLoyaltyReward(reward)"></ion-radio>
                <ion-label class="field__loyalty-list-item-text" [color]="'main-dark'" [innerHTML]="reward.name"></ion-label>
              </ion-item>
            </ion-radio-group>
          </div>
          <ng-container *ngTemplateOutlet="cartItemsTemplate"></ng-container>

          <div class="price">

            <div *ngIf="cartStore.totalDiscountsPrice && cartStore.totalDiscountsPrice > 0" class="price__block">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Discounts
                <span class="price__label-button" *ngIf="!isShowDiscountList" (click)="isShowDiscountList = true">&nbsp;&nbsp;</span>
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">- {{getFormattedPrice(cartStore.totalDiscountsPrice) | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div *ngIf="isShowDiscountList">
              <div class="price__hidden-block" *ngFor="let discount of cartStore.discountsFromOrders; index as i">
                <span class="price__label price__label--gray">{{discount.name}}</span>
                <span class="price__amount price__amount--gray">{{ getFormattedPrice(discount.applied_money.amount / 100) | currency:currency:'symbol-narrow'}}</span>
              </div>
            </div>

            <div class="price__block">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Subtotal
                <span class="price__label-button" *ngIf="!isShowInclusiveTaxesList && cartStore.inclusiveTaxesFromOrders.length > 0" (click)="isShowInclusiveTaxesList = true">&nbsp;&nbsp;</span>
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">{{ getFormattedPrice(cartStore.totalPrice + (isDisplayKyooFee() ? cartStore.kyooFee/100 : 0)) | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div *ngIf="isShowInclusiveTaxesList">
              <div class="price__hidden-block" *ngFor="let tax of cartStore.inclusiveTaxesFromOrders; index as i">
                <span class="price__label price__label--gray">&nbsp;&nbsp;(includes {{ getFormattedPrice(tax.applied_money.amount / 100) | currency:currency:'symbol-narrow'}} for {{tax.name}})</span>
              </div>
            </div>

            <div class="price__block">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Taxes and fees
                <span class="price__label-button" *ngIf="!isShowExclusiveTaxesList && cartStore.exclusiveTaxesFromOrders.length > 0" (click)="isShowExclusiveTaxesList = true">&nbsp;&nbsp;</span>
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">{{getFormattedPrice(totalTaxesPrice -  (isDisplayKyooFee() ? cartStore.kyooFee/100 : 0)) | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div *ngIf="isShowExclusiveTaxesList">
              <div class="price__hidden-block" *ngFor="let tax of cartStore.exclusiveTaxesFromOrders; index as i">
                <span class="price__label price__label--gray">&nbsp;&nbsp;{{percentageToNumber(tax.percentage)}}% {{tax.name}} - {{getFormattedPrice(tax.applied_money.amount / 100) | currency:currency:'symbol-narrow'}}</span>
              </div>
            </div>

            <div *ngIf="isShowExclusiveTaxesList && !isDeliverySelected">
              <span class="price__label price__label--gray">&nbsp;&nbsp;{{serviceChargeText}} - {{getFormattedPrice(cartStore.kyooFee / 100) | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div class="price__block" *ngIf="this.cartStore.deliveryResponseData && isDeliverySelected">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Delivery fee
                <span class="price__label--gray" *ngIf="isEstimateHaveExpiresTime && isShowCountdown">
                  (valid for <countdown #countdown [config]="countdownConfig" (event)="expiresTimeoutStop($event)"></countdown>)
                </span>
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">${{ getFormattedPrice(cartStore.deliveryFee / 100) }}</span>
            </div>

            <div class="price__block" *ngIf="isShowDriverTip && !sharedOrderId" #tipAmountField>
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">
                Driver Tip
                <span
                  *ngIf="(getGratuityPercent(tip.driver) || calculateGratuityPercent(cartStore.getTip(tip.driver))) !== 0">
                  ({{showTipsExpanded ? calculateGratuityPercent(cartStore.getTip(tip.driver)) : getGratuityPercent(tip.driver)}}%)
                </span>
                <ion-button
                  size="small"
                  fill="clear"
                  color="brand"
                  *ngIf="!driverShowTipExpand"
                  [disabled]="isDisablingCheckoutInfo"
                  (click)="expandTips(tip.driver)"
                  class="edit-tip-button">
                  Edit
                </ion-button>
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">{{getFormattedPrice(cartStore.getTip(tip.driver)) | currency:currency:'symbol-narrow'}}</span>
            </div>
            <app-tipping *ngIf="isShowDriverTip" [useAutoGratuityPercent]="!showTips(tip.driver)"
                         [hidden]="!showTips(tip.driver)" [smartTippingThreshold] = "defaultSmartTippingThreshold"
                         [items]="tipAmounts" [forceTouched]="forceTouched" [type]="tipType" [tipType]="tip.driver" [isDelivery]="isDeliverySelected"
                         [deliveryType]="deliveryType" [availableRestaurant]="availableRestaurant"
                         (validChange)="tippingInvalid = !$event"></app-tipping>

            <div class="price__block" *ngIf="isShowRestaurantTip && !sharedOrderId" #tipAmountField>
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">
                {{isDeliverySelected ? 'Restaurant Tip' : 'Tip'}}
                <span
                  *ngIf="(getGratuityPercent(tip.restaurant) || calculateGratuityPercent(cartStore.getTip(tip.driver))) !== 0">
                  ({{showTipsExpanded ? calculateGratuityPercent(cartStore.getTip(tip.restaurant)) : getGratuityPercent(tip.restaurant)}}%)
                </span>
                <ion-button
                  size="small"
                  fill="clear"
                  color="brand"
                  *ngIf="!showTipsExpanded"
                  [disabled]="isDisablingCheckoutInfo"
                  (click)="expandTips(tip.restaurant)"
                  class="edit-tip-button">
                  Edit
                </ion-button>
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">{{getFormattedPrice(cartStore.getTip(tip.restaurant)) | currency:currency:'symbol-narrow'}}</span>
            </div>
            <app-tipping *ngIf="isShowRestaurantTip" [useAutoGratuityPercent]="!showTips(tip.restaurant)"
                         [hidden]="!showTips(tip.restaurant)" [smartTippingThreshold] = "defaultSmartTippingThreshold"
                         [items]="tipAmounts" [forceTouched]="forceTouched" [type]="tipType" [tipType]="tip.restaurant" [isDelivery]="isDeliverySelected"
                         [deliveryType]="deliveryType" [availableRestaurant]="availableRestaurant"
                         (validChange)="tippingInvalid = !$event"></app-tipping>

            <div *ngIf="flexibleGiftCardBalance > 0" class="price__block">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">
                Gift Card Applied
              </span>
              <span class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">- {{flexibleGiftCardBalance | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div class="price__divider"></div>
            <div class="price__block">
              <span class="price__label price__label--total {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Total</span>
              <span class="price__amount price__amount--total {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">
                {{getFormattedPrice(total) | currency:currency:'symbol-narrow'}}
              </span>
            </div>
          </div>
        </div>
        <ng-container *ngIf="!this.restaurantStore.group?.groupId">
          <div class="promo-codes" *ngIf="showPromoCodeField">
            <div class="promo-codes__input">
              <input class="promo-codes__input-field"
                     placeholder="Enter a promo code"
                     [disabled]="paymentStore.isWaitingUpdate"
                     [(ngModel)]="promoCode"/>
              <button class="promo-codes__input-button"
                      *ngIf="!isApplyingPromoCode"
                      [disabled]="paymentStore.isWaitingUpdate || !promoCode"
                      (click)="sendPromoCode(promoCode)">
                {{applyPromoCodeText}}
              </button>
              <div class="promo-codes__input-button promo-codes__input-spinner" *ngIf="isApplyingPromoCode">
                <app-spinner></app-spinner>
              </div>
            </div>
          </div>
          <button class="remove-promo-btn"
                  *ngIf="showPromoCodeField"
                  [class.disabled-btn]="!promoCode"
                  [disabled]="!promoCode"
                  (click)="sendPromoCode(promoCode, true)">Remove promo code</button>
          <p class="promo-error" *ngIf="showWrongPromoCodeError">
            Promo code was not found, please enter a valid code.
          </p>
          <div class="swap-promo-code {{isLoading ? 'swap-payment-button-disabled' : ''}}"
               (click)="switchShowingPromoCodes()" *ngIf="restaurant?.showPromoCodeField && !sharedOrderId">
            {{switchPromoCodeText}}
          </div>
        </ng-container>
      </div>
      <div class="continue-shopping" *ngIf="isStoneCreek">
        <ion-button (click)="navigateBack()" class="checkout-btns__btn" color="brand" expand="block">
              Continue Shopping
        </ion-button>
      </div>
      <ng-container *ngIf="!sharedOrderId">
        <div *ngIf="showPhoneFieldBottom else phoneVerification"></div>
      </ng-container>
      <ng-template #phoneVerification>
        <div class="field" *ngIf="(showPhoneNumber && !isDeliverySelected && !sharedOrderId)" #phoneField>
          <div class="field__title">{{ isStoneCreek ? 'Enter Phone Number' : 'Order status notifications '}}
            <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
              <use xlink:href="./assets/images/icons-sprite.svg#icon-call"></use>
            </svg>
          </div>
          <ion-text class="field__description">You will receive text messages when your order status changes</ion-text>
          <ng-container *ngTemplateOutlet="phoneFieldTemplate"></ng-container>
          <div class="field__footer">
            Message and data rates may apply, reply HELP for help and STOP to cancel.
            <div>
              <span class="field__footer-link" (click)="openLink(termsLink)">Terms of Service</span>, <span class="field__footer-link" (click)="openLink(privacyLink)">Privacy Policy</span>
            </div>
          </div>
        </div>
        <app-ikon-pass
          *ngIf="paymentStore.customer?.orderBotUserId
        && !this.restaurantStore.group?.groupId && restaurant.enableIkonPass"
          (ikonPassResponse)="updateIconOrder()">
        </app-ikon-pass>
      </ng-template>
      <div *ngIf="!paymentStore.createTabChecked">
        <ng-container *ngTemplateOutlet="giftCardTemplate"></ng-container>
      </div>

      <div class="field field-last" #paymentField>
        <div class="field__title" *ngIf="!sharedOrderId">Payment
          <svg class="field__title-icon" xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="./assets/images/icons-sprite.svg#icon-card"></use>
          </svg>
        </div>
        <app-payment *ngIf="restaurant || group" [forceTouched]="forceTouched" [token]="token" [restaurant]="restaurant" [tabOptionSelected]="tabOptionSelected"
                     [invalid]="invalid || disabledSubmit" [isLoading]="isLoading" [isSubscription]="isSubscriptionCheckout" [group]="group" [restaurants]="groupRestaurants"
                     (onWalletForceTouched)="onWalletTouched($event)" (paymentItemError)="showPaymentError($event)"></app-payment>
        <span class="checkout-btns__error" *ngIf="currentPaymentErrorMessage && !paymentStore.isWalletPayment">{{currentPaymentErrorMessage}}</span>
      </div>
      <div class="checkout-btns">
        <ion-button (click)="submit()"
                    [disabled]="disabledSubmit"
                    id="checkout-submit"
                    class="checkout-btns__btn" color="brand" expand="block">
          {{payButtonText}}
        </ion-button>
        <p class="checkout-btns__error" *ngIf="payButtonErrorText">{{payButtonErrorText}}</p>
        <ion-button (click)="cancel()" fill="clear" class="checkout-btns__btn checkout-btns__cancel-btn" expand="block">
          Cancel order
        </ion-button>
      </div>
    </div>
    <div class="container__content" *ngIf="isTab">
      <div class="field">
        <div class="field__title">This round's summary
          <svg class="field__title-icon field__title-icon--large" xmlns="http://www.w3.org/2000/svg">
            <use xlink:href="./assets/images/icons-sprite.svg#icon-cart"></use>
          </svg>
        </div>
        <app-loyalty-banner *ngIf="showLoyaltyBanner" [withBorder]="false" [loyaltyBannerType]="loyaltyBannerType"></app-loyalty-banner>
        <div class="field__content">
          <ng-container *ngTemplateOutlet="cartItemsTemplate"></ng-container>

          <div class="price">
            <div class="price__block">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Subtotal</span>
              <span
                class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">{{getFormattedPrice(cartStore.totalPrice + (isDisplayKyooFee() ? cartStore.kyooFee/100 : 0)) | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div class="price__block">
              <span
                class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Taxes and fees</span>
              <span
                class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">{{getFormattedPrice(totalTaxesPrice -  (isDisplayKyooFee() ? cartStore.kyooFee/100 : 0)) | currency:currency:'symbol-narrow'}}</span>
            </div>

            <div *ngIf="cartStore.totalDiscountsPrice > 0" class="price__block">
              <span class="price__label {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Discounts</span>
              <span
                class="price__amount {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">- {{getFormattedPrice(cartStore.totalDiscountsPrice) | currency:currency:'symbol-narrow'}}</span>
            </div>
            <div class="price__divider"></div>
            <div class="price__block">
              <span
                class="price__label price__label--total {{isDisablingCheckoutInfo ? 'price__label--gray' : ''}}">Total</span>
              <span
                class="price__amount price__amount--total {{isDisablingCheckoutInfo ? 'price__amount--gray' : ''}}">
                {{getFormattedPrice(total) | currency:currency:'symbol-narrow'}}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="checkout-btns">
        <ion-button (click)="addOrdersToTab()"
                    [disabled]="disabledSubmit"
                    class="checkout-btns__btn" color="brand"
                    expand="block">
          Add to tab
        </ion-button>
        <p class="checkout-btns__error" *ngIf="payButtonErrorText || tabError">{{tabError ? tabErrorMessage : payButtonErrorText}}</p>
        <ion-button (click)="addOrderAndCloseTab()"
                    [disabled]="disabledSubmit"
                    fill="clear" class="checkout-btns__btn checkout-btns__cancel-btn" expand="block">
          Order this round and close tab
        </ion-button>
      </div>
    </div>
  </div>
  <div class="spinner-wrapper"
       id="checkout-spinner"
       *ngIf="isLoading"
    >
    <div class="fridge" *ngIf="isSubmitting && isFridgeSelected">Preparing to unlock  fridge try now</div>
    <app-spinner></app-spinner>
  </div>
  <app-notification-modal [modalInfo]="notificationInfo" (close)="notificationModalClosed()"
                          *ngIf="isShowNotificationModal">
  </app-notification-modal>
</ion-content>

<!-- ============ CART ITEMS TEMPLATE =========== -->
<ng-template #cartItemsTemplate>
  <app-cart-item *ngFor="let cartItem of menuItemsInCart; let first = first; index as i"
                 [item]="cartItem"
                 [hasEdit]="true"
                 [showTimeBasedErrorMessage]="showTimeBasedErrorMessage"
                 [isValidLeadTime]="itemLeadTimeValid(cartItem)"
                 [isValidDay]="itemAvailableDaysValid(cartItem)"
                 [isValidFulfillment]="itemAvailableFulfillmentValid(cartItem)"
                 [isValidDatetimeRange]="itemAvailableDatetimeRange(cartItem)"
                 [isValidRestaurantFulfillment]="itemRestaurantAvailableFulfillment(cartItem)"
                 [isValidRestaurantTime]="itemRestaurantAvailableTime(cartItem)"
                 [showModifierPrice]="!isTab"
                 [currencySign]="currencySign"
                 [serviceChargeName]='restaurant?.serviceChargeName'
                 (edit)="editItem(i)"
                 (delete)="deleteItemFromCart(i)"
                 [buttonsDisabled]="isDisablingCheckoutInfo"
                 [displayKyooFee]="restaurant?.displayKyooFeeOnMenu && first"
  ></app-cart-item>
</ng-template>

<!-- ============ PHONE INPUT FIELD TEMPLATE =========== -->
<ng-template #phoneFieldTemplate>
  <div id="phone-number-field">
    <app-verify-phone-number
      [forceTouched]="forceTouched"
      [isUpdating]="paymentStore?.isWaitingUpdate"
      [isDisableQuickCheckout]="isDisableQuickCheckout"
      [isSharedCardsEnabled]="isSharedCardsEnabled"
      [isNeedSharingPhoneNumber]="isNeedSharingPhoneNumber"
      (validChange)="phoneInvalid = !$event"
      (authoriseCustomer)="authoriseCustomer($event)"
      (saveCustomerData)="saveCustomerData($event)"
      (isPhoneValid)="checkPhoneValidation($event)"
      (setCustomerLoyaltyRewards)="customerLoyaltyRewards($event)"
      >
    </app-verify-phone-number>
  </div>
</ng-template>

<!-- ============ GIFT CARD TEMPLATE =========== -->
<ng-template #giftCardTemplate>
  <app-gift-cards>

  </app-gift-cards>
</ng-template>
